var map = {
	"./images/hangover-1-mobile.png": 5348,
	"./images/hangover-1-pc.png": 6601,
	"./images/hangover-2-mobile.png": 5197,
	"./images/hangover-2-pc.png": 2960,
	"./images/hangover-3-mobile.png": 7366,
	"./images/hangover-3-pc.png": 1695,
	"./images/hangover-4-mobile.png": 7831,
	"./images/hangover-4-pc.png": 1414,
	"./images/hangover-5-mobile.png": 7472,
	"./images/hangover-5-pc.png": 7861,
	"./images/hangover-6-mobile6.png": 1739,
	"./images/hangover-7-mobile.png": 6786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5488;